var groupCtrl = (function () {
  return {

    groupNew: function ($scope, Api) {

      $scope.newCB = function (response) {
        var page_id = response.response;
        window.location.href = `/manage.app#!/group/groups/${page_id}`;
      }

    },

    group: function ($scope, Api) {
      if (!$scope.project_data.plan.groups_feature_enabled) return false;

      $scope.blogs = false;
      $scope.currentPage = 1;
      $scope.searchKw = '';
      $scope.searchMode = 'AUTHOR';
      $scope.total = 0;

      // Group Counters
      $scope.counters = {
        'OWNER': 0,
        'AUTHOR': 0,
        'ALL': 0
      }
      var counter = function (key) {
        Api.get(`blogs/counter?mode=${key}`, function (err, resp) {
          if (!err) $scope.counters[key] = resp.response;
        });
      }
      for (var key in $scope.counters) counter(key);

      $scope.list = function (page, kw, mode) {
        $scope.blogs = false;
        $scope.currentPage = page;
        $scope.searchKw = kw;
        $scope.searchMode = mode;
        Api.get(`blogs/get?page=${page}&page_size=10&filter=${kw}&mode=${mode}`, function (err, resp) {
          if (!err) {
            $scope.blogs = resp.response;
            $scope.total = resp.total;
          }
        });
      }

      // Change role
      $scope.group_exit = function (page_id) {
        Api.put('user/link_to_group', {action: 'delete', page_id: page_id}, function (err, resp) {
          $scope.list($scope.currentPage, $scope.searchKw, $scope.searchMode);
          for (var key in $scope.counters) counter(key);
        });
      }

      $scope.list(1, $scope.searchKw, $scope.searchMode);

      $scope.redirectGroups = function () {
        window.location.href = '/groups';
      }
    },

    groupDetail: function ($scope, Api, NgTableParams, ReqAndUpload, $q, $translate) {

      $scope.currentPage = 1;
      $scope.kw = '';
      $scope.user_searching = false;

      $('#user_search').autocomplete({
        search: function () {
          $scope.user_searching = true;
        },
        response: function () {
          $scope.user_searching = false;
        }
      });

      // Post count
      $scope.post_count = 0;
      Api.get(`article/counter?status=PUBLISHED&mode=ALL&page_id=${$scope.id}`, function (err, resp) {
        if (!err) $scope.post_count = resp.response;
      });

      // Pre update group
      $scope.preUpdate = function (group) {
        delete group.author_id;
        delete group.author_name;
        delete group.author_slug;
        delete group.created;
        delete group.followers_count;
        delete group.id;
        delete group.owner;
        delete group.posts_count;
        delete group.role;
        delete group.url;
        delete group.writers_count;
      }

      $scope.cbUpdate = function () {
        $scope.loadData('blogs/get/id', 'group');
      }

      // Get user list
      $scope.users = {
        itens: [],
        total: 0
      };
      $scope.list = function (page, kw) {
        $scope.currentPage = page;
        var filter = `signup_pending=false&page=${$scope.currentPage}&page_size=20&filter=${kw ? kw : ''}&page_id=${$scope.id}`;
        Api.get(`user/list?${filter}`, function (err, resp) {
          if (!err) {
            $scope.noresults = resp.response.data.length > 0 ? false : true;
            $scope.last = resp.response.data.length == 20 ? false : true;
            $scope.users = {
              itens: resp.response.data,
              total: resp.response.total
            };
          }
        });

      }

      $scope.list(1);

      // Show user data from item select on suggest input
      $scope.preAddUser = function (user) {
        Api.get(`user/get/${user.id}`, function (err, data) {
          $scope.newUser = data.response;
        })
      }

      // Add new user
      $scope.addNewUser = function (user) {
        if (!user) {
          return $translate('GROUP.USER_ADD_INVALID_UNSELECTED_USER').then(function (result) {
            App.toast(result, 3000);
          });
        }

        Api.post(`user/link_to_group/${user._id}`, {role: 'USR', group_id: $scope.id}, function (err, ret) {
          if (!err && ret.response === 'USER_LINK_TO_GROUP_CREATED') {
            $('#add_user').closeModal();
            $scope.newUser = false;
            $scope.new_user = '';
            $scope.list(1);
          } else {
            if (ret.response && ret.response.errorCode && ret.response.errorCode === 'USER_ALREADY_IN_GROUP') {
              $translate('GROUP.USER_ADD_INVALID_USER').then(function (result) {
                App.toast(result, 3000);
              });
            }
          }
        })
      }


    }

  }
})();
